import { Link } from 'react-router-dom';
import { CONTACT_INFO, SERVICES } from '../data';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary-green text-white border-t-4 border-secondary-green">
      {/* Main Footer Content */}
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12">
          {/* Column 1: About & Info */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <img 
                src="https://assets.auxodev.dk/assets/340cd821-77c4-4f44-a38b-9945cfcac15b/logo-4.png" 
                alt="Haveglæde Logo" 
                className="h-10 w-auto object-contain bg-white p-1 rounded-sm"
                onError={(e) => {
                  e.target.src = "/images/auxo_logo_white.png";
                }}
              />
              <span className="font-display text-lg font-bold tracking-wide">HAVEGLÆDE</span>
            </div>
            <p className="text-xs text-gray-300 leading-relaxed max-w-sm">
              Din lokale og pålidelige gartner i Esbjerg og omegn. Vi leverer professionel haveservice og anlægsarbejde i højeste kvalitet.
            </p>
            <div className="pt-2 text-xs text-gray-300 space-y-1">
              <p><strong className="text-secondary-green">CVR:</strong> {CONTACT_INFO.cvr}</p>
              <p><strong className="text-secondary-green">Ejer:</strong> Michael Poul Ewers Petersen</p>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <h3 className="font-display text-xs font-bold uppercase tracking-wider text-secondary-green mb-4">
                Navigation
              </h3>
              <ul className="space-y-2 text-xs text-gray-300">
                <li>
                  <Link to="/" className="hover:text-white transition-colors">Forside</Link>
                </li>
                <li>
                  <Link to="/om-haveglaede" className="hover:text-white transition-colors">Om os</Link>
                </li>
                <li>
                  <Link to="/referencer" className="hover:text-white transition-colors">Referencer</Link>
                </li>
                <li>
                  <Link to="/kontakt" className="hover:text-white transition-colors">Kontakt</Link>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="font-display text-xs font-bold uppercase tracking-wider text-secondary-green mb-4">
                Ydelser
              </h3>
              <ul className="space-y-2 text-xs text-gray-300">
                {SERVICES.map((service) => (
                  <li key={service.slug}>
                    <Link to={`/ydelser/${service.slug}`} className="hover:text-white transition-colors">
                      {service.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Column 3: Contact Details */}
          <div className="space-y-4 md:col-span-2 lg:col-span-1">
            <h3 className="font-display text-xs font-bold uppercase tracking-wider text-secondary-green">
              Kontaktoplysninger
            </h3>
            <ul className="space-y-3 text-xs text-gray-300">
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-location-dot text-secondary-green mt-0.5" />
                <span>{CONTACT_INFO.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-solid fa-phone text-secondary-green" />
                <a 
                  href={`tel:${CONTACT_INFO.phoneRaw}`} 
                  className="hover:text-white transition-colors whitespace-nowrap"
                >
                  <span className="whitespace-nowrap">{CONTACT_INFO.phone}</span>
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-solid fa-envelope text-secondary-green" />
                <a 
                  href={`mailto:${CONTACT_INFO.email}`} 
                  className="hover:text-white transition-colors whitespace-nowrap"
                >
                  <span className="whitespace-nowrap">{CONTACT_INFO.email}</span>
                </a>
              </li>
              <li className="flex items-start gap-3 pt-2 border-t border-primary-green-light/30">
                <i className="fa-solid fa-clock text-secondary-green mt-0.5" />
                <div className="space-y-1 text-[11px]">
                  <p>{CONTACT_INFO.hours}</p>
                  <p>{CONTACT_INFO.hoursWeekend}</p>
                  <p className="text-secondary-green italic">{CONTACT_INFO.hoursMails}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 border-t border-primary-green-light/30 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-gray-400">
          <p>© {currentYear} {CONTACT_INFO.name}. Alle rettigheder forbeholdes.</p>
        </div>
      </div>
    </footer>
  );
}
